<div class="modal-header d-flex justify-content-center">
  <h3 class="dialog-title mb-0">{{ 'Assign Notification' | translate }}</h3>
</div>
<app-progress-spinner [show]="isFormLoading"></app-progress-spinner>
<div class="mb-4">
  <div mat-dialog-content>
    <div class="row">
      @if (data) {
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <mat-form-field class="w-100">
                <mat-label>{{'Choose Category' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedCustomObjectId" (selectionChange)="onEndpointSelect()">
                  @for (customObject of customObjects; track trackById($index, customObject)) {
                    <mat-option [value]="customObject.customObjectId">
                      {{ customObject.customObjectName }}
                    </mat-option>
                  }
                </mat-select>
                <mat-icon matPrefix class="mr-3">
                  <i class="{{ selectedCustomObjectIcon }}"></i>
                </mat-icon>
              </mat-form-field>
              <mat-form-field class="w-100 mt-3">
                <mat-label>{{'End Point Assignments' | translate}}
                  ({{endPointsList?.selected ? data.assignedEndPoints.length - 1 :
                  data.assignedEndPoints.length }})
                </mat-label>
                <mat-select [(ngModel)]="data.assignedEndPoints" multiple>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="searchControl" placeholderLabel="Search..."></ngx-mat-select-search>
                  </mat-option>
                  @if ((filteredEndPoints | filter: searchControl.value).length > 1) {
                    <mat-option #endPointsList
                      (click)="toggleAllEndPointsSelection()" [value]="0">
                      {{'Select All' | translate }}
                    </mat-option>
                  }
                  @if ((filteredEndPoints | filter: searchControl.value).length === 0) {
                    <mat-option class="no-option-found" disabled>
                      {{'No options found' | translate}}
                    </mat-option>
                  }
                  @for (endPoint of filteredEndPoints | filter: searchControl.value; track trackById($index, endPoint)) {
                    <mat-option [value]="endPoint.id"
                      (click)="toggleOneEndPointSelection()">
                      {{endPoint.name}}
                    </mat-option>
                  }
                </mat-select>
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-desktop"></i>
                </mat-icon>
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div mat-dialog-actions class="px-4">
    <button class="btn modal-footer-btn save-modal-btn" [class.cursor-not-allowed]="isLoading" (click)="save()"
    [disabled]="isLoading">{{'Save' | translate }}</button>
    <button class="btn modal-footer-btn cancel-modal-btn" mat-dialog-close (click)="close()">{{'Cancel' | translate }}</button>
  </div>
</div>